<form #form="ngForm" class="pessoa-ipi-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                IPI
            </h6>
            <p class="form-text text-muted">
                Dados do IPI (Imposto sobre Produtos Industrializados) da empresa
            </p>
        </div>  

        <div class="card-body" *ngIf="entity">
            <div class="row">
                <div class="form-group col-12">             
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.isentoIpi" name="isentoIpi" id="isentoIpi"
                            [disabled]="!canEdit" [readonly]="!canEdit">
                        <label class="custom-control-label" for="isentoIpi">
                            Isento de IPI?
                        </label>
                    </div>                    
                    <p class="form-text text-muted">
                        Marque esta opção se o cliente for isento de IPI
                    </p>                                           
                </div>                
            </div>
            <div class="row ipi-datas">
                <div class="form-group col-12 col-md">
                    <label>Data Validade Carta Isenção IPI</label>
                    <input type="text" class="form-control" [value]="entity.dataValidadeCartaIsencaoIpi | date: 'dd/MM/yyyy'" disabled="disabled" readonly="readonly">
                </div>
            </div>
        </div>
    </div>
</form>